import { takeLatest, put, call, all } from 'redux-saga/effects';
import {
    addNewAdvanceRequest,
    addNewAdvanceSuccess,
    addNewAdvanceFailure,
    fetchAdvanceDataRequest,
    fetchAdvanceDataSuccess,
    fetchAdvanceDataFailure,

    startAdvanceOnlyBasicFecth,
    fetchAdvanceByIdSuccess,
    fetchAdvanceByIdFailure,

    updateExistingAdvanceRequest,
    updateExistingAdvanceSuccess,
    updateExistingAdvanceFailure,

    startDeleteAdvance,
    deleteAdvanceSuccess,
    deleteAdvanceFailure,

    fetchAdvanceDataByFilterRequest,
    fetchAdvanceDataByFilterSuccess,
    fetchAdvanceDataByFilterFailure
} from '../../store1/advance data/advanceData.slice';

import { 
    addNewAdvanceAPI, 
    fetchAdvanceDataAPI,
    fetchAdvanceByIdAPI,
    updateAdvanceAPI,
    deleteAdvanceAPI,
    fetchAdvanceDataByFilterAPI
} from 'Api/AdvanceAPI/advanceApi'; 

import { setNotificationAction } from '../NotificationStore/notification.slice.selector';
import { setFormNavigate } from 'store1/formnavigation/formnavigation';

// API call function for adding new advance
function* watchAddNewAdvance() {
    yield takeLatest(addNewAdvanceRequest.type, handleAddNewAdvance);
}

function* handleAddNewAdvance(action) {
    try {
        const newAdvance = yield call(addNewAdvanceAPI, action.payload);
        yield put(addNewAdvanceSuccess(newAdvance));
        yield put(setNotificationAction({ message: 'Advance added successfully!', variant: 'success' }));
        yield put(setFormNavigate(true));
    } catch (error) {
        yield put(addNewAdvanceFailure(error.message));
        yield put(
            setNotificationAction({
                message: `Failed to add advance: ${error.message}`,
                variant: 'error',
            })
        );
    }
}

// ..........................................................
// API call function for fetching advance data
function* watchFetchAdvanceData() {
    yield takeLatest(fetchAdvanceDataRequest.type, handleFetchAdvanceData);
}

function* handleFetchAdvanceData(action) {
    try {
        // yield put(fetchAdvanceDataRequest()); 
        const advanceData = yield call(fetchAdvanceDataAPI, action.payload);
        yield put(fetchAdvanceDataSuccess(advanceData));
    } catch (error) {
        yield put(fetchAdvanceDataFailure(error.message));
        yield put(
            setNotificationAction({
                message: `Failed to fetch advance data: ${error.message}`,
                variant: 'error',
            })
        );
    }
}

// ..........................................................
// API call function for edit advance data 
function* watchFetchAdvanceById() {
    yield takeLatest(startAdvanceOnlyBasicFecth.type, handleFetchAdvanceById);
}

function* handleFetchAdvanceById(action) {
    try {
        // yield put(fetchAdvanceDataRequest()); 
        const advanceData = yield call(fetchAdvanceByIdAPI, action.payload);
        yield put(fetchAdvanceByIdSuccess(advanceData));
    } catch (error) {
        yield put(fetchAdvanceByIdFailure(error.message));
        yield put(
            setNotificationAction({
                message: `Failed to fetch advance details: ${error.message}`,
                variant: 'error',
            })
        );
    }
}

// ..........................................................
// API call function for updating existing advance
function* watchUpdateExistingAdvance() {
    yield takeLatest(updateExistingAdvanceRequest.type, handleUpdateExistingAdvance);
}

function* handleUpdateExistingAdvance(action) {
    try {
        const updatedAdvance = yield call(updateAdvanceAPI, action.payload);
        yield put(updateExistingAdvanceSuccess(updatedAdvance));
        yield put(setNotificationAction({ message: 'Advance updated successfully!', variant: 'success' }));
        yield put(setFormNavigate(true));
    } catch (error) {
        yield put(updateExistingAdvanceFailure(error.message));
        yield put(
            setNotificationAction({
                message: `Failed to update advance: ${error.message}`,
                variant: 'error',
            })
        );
    }
}

// ..........................................................
// API call function for deleting existing advance 
function* watchDeleteAdvance() {
    yield takeLatest(startDeleteAdvance.type, handleDeleteAdvance);
}

function* handleDeleteAdvance(action) {
    try {
        const { deleteId, tableData } = action.payload;
        const deletedId = yield call(deleteAdvanceAPI, deleteId);
        yield put(deleteAdvanceSuccess(deletedId));
        yield put(setNotificationAction({ message: 'Advance deleted successfully!', variant: 'success' }));
        yield put(fetchAdvanceDataRequest(tableData));
    } catch (error) {
        yield put(deleteAdvanceFailure(error.message));
        yield put(
            setNotificationAction({
                message: `Failed to delete advance: ${error.message}`,
                variant: 'error',
            })
        );
    }
}

// ..........................................................
// API call function for filter existing advance 
function* watchFetchAdvanceDataByFilter() {
    yield takeLatest(fetchAdvanceDataByFilterRequest.type, handleFetchAdvanceDataByFilter);
}

function* handleFetchAdvanceDataByFilter(action) {
    try {
        const filteredData = yield call(fetchAdvanceDataByFilterAPI, action.payload);
        yield put(fetchAdvanceDataByFilterSuccess(filteredData));
    } catch (error) {
        yield put(fetchAdvanceDataByFilterFailure(error.message));
        yield put(
            setNotificationAction({
                message: `Failed to filter advance data: ${error.message}`,
                variant: 'error',
            })
        );
    }
}

// Export the watcher
export default function* advanceDataSaga() {
    yield all([
        call(watchAddNewAdvance),
        call(watchFetchAdvanceData),
        call(watchFetchAdvanceById),
        call(watchUpdateExistingAdvance),
        call(watchDeleteAdvance),
        call(watchFetchAdvanceDataByFilter),
    ]);
}


